

import { LateApproval } from "@/API/api";
import {
    checkFile, downloadFile
} from "@/util/util.js"
export default {
    
    data() {
        return {
            userInfo: JSON.parse(localStorage.getItem('userInfo')),
            allCount: 0,
            loading: false,
            finished: false,
            timesheetList: [],
            uId: JSON.parse(localStorage.getItem("userInfo")).id,
            showMore: true,
            cloums: [
                {
                    
                    title: '项目名称',
                    dataIndex: 'projectName'
                },
                {
                    title: '交付物类型',
                    dataIndex: 'deliverablesType'
                },
                {
                    title: '交付物名称',
                    dataIndex: 'nameOfDeliverables'
                },
                {
                    title: '交付物版本',
                    dataIndex: 'deliverablesVersion'
                },
                {
                    title: '工作时长',
                    dataIndex: 'workHours'
                },
                {
                    title: '难度系数',
                    dataIndex: 'difficulty'
                },
                {
                    title: '交付物上传地址',
                    dataIndex: 'yunZhouAddress'
                },
                {
                    title: '备注',
                    dataIndex: 'remark'
                },
                {
                    title: '工作描述',
                    dataIndex: 'remark'
                },
            ],
            modal1: false,
            outerItem: {},
            searchParams: {
                limit: 10,
                page: 1,
                uId: JSON.parse(localStorage.getItem("userInfo")).id,
            },
            btn: false,
            type:null,
            ourterIndex:null,
        }
    },
    methods: {
        //列表页面从后台返回的数据呈现出想要的格式
        changeShowContent(type, val) {
            let newVal
            switch (type) {
                case 'difficulty':
                    switch (val) {
                        case 1:
                            newVal = 'S'
                            break;
                        case 2:
                            newVal = 'A'
                            break;
                        case 3:
                            newVal = 'B'
                            break;
                        case 4:
                            newVal = 'C'
                            break;
                    }
                    break;
                case 'deliverablesVersion':
                    switch (val) {
                        case 1:
                            newVal = 'V1'
                            break;
                        case 2:
                            newVal = 'V2'
                            break;
                        case 3:
                            newVal = 'V3'
                            break;
                        case 4:
                            newVal = 'V4'
                            break;
                        case 5:
                            newVal = 'V5'
                            break;
                        case 6:
                            newVal = 'V6'
                            break;
                        case 7:
                            newVal = 'V7'
                            break;
                        case 8:
                            newVal = 'V8'
                            break;
                        case 9:
                            newVal = 'V9'
                            break;
                        case 10:
                            newVal = 'V10'
                            break;
                    }
                    break;
            }
            return newVal
        },
        //列表获取
        getTimesheetList() {
           
            return this.$http.post(LateApproval.getToBeReviewedByUId, this.qs.stringify(this.searchParams))

        },
        onOk(){
            //页面弹窗关闭，loading按钮，list去除一个通过或者拒绝的list
            let params={
                NId: this.uId,
                date: this.outerItem.workingDate,
                state:this.type,
                uId: Number(this.outerItem.uid),
            }
            this.btn=true;
            this.$http.post(LateApproval.updateByUId, this.qs.stringify(params)).then(res=>{
                const _data=res.data;
                
                this.timesheetList.splice(this.ourterIndex, 1)
                this.ourterIndex = null;
                this.outerItem = {};
                this.btn = false;
                this.$message({
                    message: '审核成功',
                    type: 'success'
                });
                this.modal1=false;
            }).catch(err=>{
                this.btn = false;
            }
                )
        },
        //页面滑动到底部页数+1
        onLoad() {
            if (this.allCount == this.timesheetList.length) {
                this.finished = true;
                this.loading = false;
                return
            }
            this.searchParams.page+=1
            this.$http
                .post(LateApproval.getToBeReviewedByUId, this.qs.stringify(this.searchParams))
                .then((res) => {
                    if (res.data.retCode == 0) {
                        this.loading = false;
                        let _data
                        if (res.data.retData.data != "") {
                            let _timesheetList = res.data.retData;
                            _data = this.formatTimesheetList(_timesheetList).data
                            this.timesheetList = [...this.timesheetList, ..._data];
                        }
                        if (_data.length < this.searchParams.limit || this.allCount == this.timesheetList.length) {
                            this.finished = true;
                        }
                    } else {
                        this.finished = true;
                        this.$message({
                            message: `${res.data.retMsg}`,
                            type: "warning",
                        });
                    }
                });
        },
       
        //循环接口请求回来的列表数据，处理数据
        formatTimesheetList(_timesheetList) {
            for (let i of _timesheetList.data) {
                i.showMore = true;
                for (let j of i.tsInfo) {
                    if (j.difficulty !== null) {
                        j.difficulty = this.changeShowContent('difficulty', j.difficulty)
                    }
                    if (j.deliverablesVersion !== null) {
                        j.deliverablesVersion = this.changeShowContent('deliverablesVersion', j.deliverablesVersion)
                    }
                    j.departmentNameAndpositionName = j.departmentName + ' | ' + j.positionName
                }
            }
            return _timesheetList
        },
        //查看更多、收起 
        clickItem(item, type) {
            item.showMore = !item.showMore;
        },
        //通过、驳回按钮
        auditItem(type, outerItem,index){
            this.type=type;
            this.modal1 =true;
            this.outerItem = outerItem;
            this.ourterIndex=index;
        },
        //查看链接
        goYunzhou(item) {
            console.log(item, 'item');
            let url = item.yunZhouAddress, name = item.remark2;
            console.log(url, 'url-------')
            if (url.indexOf("http://cloud.normcore.com/") > -1) {
                window.open(url, "_blank")
            } else {
            let checkFileUrl = checkFile(url);
            if (checkFileUrl == 'video') {
                window.open(url, "_blank");

            } else {
                console.log('------12344321')
                downloadFile(url, name)

            }
        }
            // window.open(item.yunZhouAddress)
        },
     getTeamByUId(){
            const { uId }=this
            let params={uId}
        this.$http.post(LateApproval.getTeamByUId, this.qs.stringify(params) ).then(res=>{
            const _data = res.data.retData;
            if (!!_data.length&&!!_data){
                (async ()=>{
                const timesheetList = await this.getTimesheetList();
                let _timesheetList = timesheetList.data.retData;
                this.timesheetList = this.formatTimesheetList(_timesheetList).data;
                this.allCount = timesheetList.data.retData.count;
                 if (this.allCount == this.timesheetList.length) {
                this.finished = true;
                this.loading = false;
            }
                })()
                
            }
        })
    },
    initTab(){
        sessionStorage.setItem("subMenu", "vacation/approval");
        this.$store.dispatch("setCurrSubMenu", "vacation/approval");
        this.$store.dispatch("setOpenedSub", ["vacation"]);
        sessionStorage.setItem("openedSub", '["vacation"]');
        this.$store.dispatch("setCurrMenu", 10);
        sessionStorage.setItem("currMenu", 10);
        sessionStorage.setItem("primaryMenu", 10);
        this.$store.dispatch("setPrimaryMenu", 10)
    },
    },
     mounted() {
        this.getTeamByUId();
        this.initTab();
      
    },
}